import { Channel } from 'src/store/models/index.js'
import Channels from 'src/api/channels.js'
import { waitFor } from 'src/config/setup/plugins/waitFor/index.js'

export default {
  data: () => ({
    channelMetrics: null,
    suggestedContentMoveGroupChannel: null,
    showContentMoveConfigurationModal: false
  }),

  computed: {
    isChannelMovable () {
      if (!this.channel?.meta) return
      return this.channel.meta.is_movable
    },

    canMoveContent () {
      if (!this.channel) return
      return this.$can('move-channel-content', this.channel)
    },

    isChannelOfCurrentSchoolYear () {
      const currentSchoolYear = this.$me.school.getCurrentActiveSchoolYear()
      return this.channelSchoolYear?.key === currentSchoolYear?.key
    },

    channelSchoolYear () {
      if (!this.channel?.group) return
      return this.$me.school.getSchoolYearByKey(this.channel.group)
    },

    hasSuggestedChannel () {
      return this.suggestedContentMoveGroupChannel && Object.keys(this.suggestedContentMoveGroupChannel).length !== 0
    },

    contentMoveInfoCardCaptions () {
      const schoolYear = this.isChannelOfCurrentSchoolYear ? 'new' : 'old'

      if (!this.hasSuggestedChannel) {
        return {
          title: this.$t(`chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.title`),
          description_1_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_1`,
          description_2_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_2`,
          description_2_subtext1_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_2_subtext1`,
          description_2_subtext2_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_2_subtext2`,
          description_2_subtext3_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_2_subtext3`,
          description_2_subtext4_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_2_subtext4`,
          description_3_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_3`,
          description_3_subtext1_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_3_subtext1`,
          description_3_subtext2_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_3_subtext2`,
          description_3_subtext3_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_3_subtext3`,
          description_3_linktext_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_3_linktext`,
          description_3_link_path: `chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.description_3_link`,
          leftAction: this.$t(`chats.content_move.info_card.cannot_move_content.from_${schoolYear}_channel.left_action`)
        }
      }

      const year = this.isChannelOfCurrentSchoolYear
        ? this.$me.school.getPreviousSchoolYear()?.meta.shortname
        : this.$me.school.getCurrentActiveSchoolYear()?.meta.shortname
      const groupName = this.suggestedContentMoveGroupChannel?.meta ? `(${this.suggestedContentMoveGroupChannel?.meta?.displayname})` : ''

      return {
        title: this.$t(`chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.title`, { year: year }),
        groupName,
        description_1_path: `chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.description_1`,
        description_2_path: `chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.description_2`,
        description_2_subtext1_path: `chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.description_2_subtext1`,
        description_2_subtext2_path: `chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.description_2_subtext2`,
        description_3_path: `chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.description_3`,
        leftAction: this.$t(`chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.left_action`),
        rightAction: this.$t(`chats.content_move.info_card.can_move_content.from_${schoolYear}_channel.right_action`)
      }
    }
  },

  methods: {
    getSuggestedGradeChannel: waitFor('suggested-grade-content-move', async function () {
      const res = await Channels.getSingleRelatedChannelForContentMove(this.channel.id)
      this.suggestedContentMoveGroupChannel = res.data
    }),

    declineContentMove: waitFor('decline-content-move', async function () {
      const res = this.isChannelOfCurrentSchoolYear ? await Channels.putChannelContentMoveStartEmpty(this.channel.id) : await Channels.putChannelContentMoveArchive(this.channel.id)

      await Channel.insertOrUpdate({ data: res.data })
      this.showContentMoveDeclineModal = false
    }),

    showContentMoveConfiguration: waitFor('channel-metrics', async function () {
      // if channel is from current schoolyear -> Channels.getChannelsByIdMetrics(this.suggestedContentMoveGroupChannel.id)
      // if channel is from old schoolyear ->  Channels.getChannelsByIdMetrics(this.channel.id)
      const channelId = this.isChannelOfCurrentSchoolYear ? this.suggestedContentMoveGroupChannel.id : this.channel.id
      const res = await Channels.getChannelsByIdMetrics(channelId)
      this.channelMetrics = res.data
      this.showContentMoveConfigurationModal = true
    })
  },
  watch: {
    channel: {
      handler: async function (val) {
        if (!val || this.suggestedContentMoveGroupChannel || !this.canMoveContent || this.$wait.waiting('suggested-grade-content-move')) {
          return
        }
        await this.getSuggestedGradeChannel()
      },
      immediate: true
    }
  }
}
